import React from 'react'
import AdminNavbar from './AdminNavbar'

export default function HomepageBanner() {
  return (
    <div>
      <AdminNavbar />
    </div>
  )
}
